import React, { useState, useEffect } from 'react';
import { Modal, Button, Input, Checkbox } from 'antd'; // <--- Importamos Checkbox
import { EditOutlined } from '@ant-design/icons';
import styles from './PaperlessPush.styles.js';

export default function EditDeviceModal({ state, actions, translate }) {
  const [inputValue, setInputValue] = useState('');
  const [paperlessLockCarrusel, setPaperlessLockCarrusel] = useState(false);
  const [showError, setShowError] = useState(false);
  useEffect(() => {
    if (state.selectedDevice?.deviceConfig?.paperlessLockCarrusel) {
      setPaperlessLockCarrusel(state.selectedDevice?.deviceConfig?.paperlessLockCarrusel);
    }
  }, [state.selectedDevice, state.selectedDeviceUUID]);

  const handleSave = () => {
    const nameToSave = inputValue.trim() ? inputValue : state.selectedDeviceUUID;

    if (!nameToSave) {
      setShowError(true);
      return;
    }

    actions.onSaveEditDevice(nameToSave, paperlessLockCarrusel);

    setShowError(false);
    actions.setShowDeviceModal(false);
  };

  return (
    <Modal open={true} onCancel={() => actions.setShowDeviceModal(false)} footer={null}>
      <div style={styles.editIcon}>
        <EditOutlined style={{ fontSize: 24 }} />
      </div>

      <div style={styles.editTitle}>{translate('paperlessPush.editDeviceModal.editTitle')}</div>

      <div style={styles.editDescription}>
        {translate('paperlessPush.editDeviceModal.editDescription')}
      </div>

      <div style={styles.editDescription}>
        {translate('paperlessPush.editDeviceModal.editNote')}
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
          {translate('paperlessPush.editDeviceModal.editInputName')}
        </label>
        <Input
          placeholder={state.selectedDeviceUUID}
          value={inputValue}
          onChange={e => {
            setInputValue(e.target.value);
            setShowError(false);
          }}
        />
        {showError && (
          <p style={{ color: 'red', marginTop: 4 }}>
            {translate('paperlessPush.editDeviceModal.errors.emptyName')}
          </p>
        )}
      </div>
      <div>
        <Checkbox
          checked={paperlessLockCarrusel}
          onChange={e => setPaperlessLockCarrusel(e.target.checked)}
        >
          {translate('paperlessPush.editDeviceModal.lockCarruselLabel')}
        </Checkbox>
      </div>

      <div>
        <Button key="save" type="primary" onClick={handleSave} style={styles.saveButtonContainer}>
          {translate('paperlessPush.editDeviceModal.saveButton')}
        </Button>
      </div>
    </Modal>
  );
}
